<template>
  <div class="vacancy-steps">
    <component :is="`style`">
      .steps { height: calc(100vh - {{ headerHeight }}px); }
    </component>
    <div class="steps" v-if="stages.length">
      <Step v-for="(item, i) in stages" :key="i" :item="item" />
    </div>
    <div v-else class="empty-stages">Нет данных по этапам</div>
    <div class="vacancy-steps__footer">
      <form-buttons
        :buttons_menu="bottomButtons"
        view-type="detail"
      ></form-buttons>
    </div>
  </div>
</template>

<script>
import { store } from '@/store';
import Step from 'Elements/Step/Step';
import FormButtons from 'Elements/Form/FormButtons';

export default {
  created() {
    setTimeout(() => {
      this.headerHeight =
        document.getElementsByClassName('header')[1].offsetHeight + 88;
    }, 0);
  },
  data() {
    return {
      headerHeight: 0,
      footerHeight: 0
    };
  },
  computed: {
    stages() {
      return store.state.rightPanel.panelMode == 'canditateStagePanel'
        ? store.state.rightPanel.metadata?.content?.data
        : [];
    },
    bottomButtons() {
      return store.state.rightPanel.metadata?.bottom_buttons || [];
    }
  },
  components: { Step, FormButtons }
};
</script>

<style lang="scss" scoped>
.footer-bar {
  align-content: center;
  display: flex;
  justify-content: center;
  vertical-align: middle;
  border-top: 1px solid $black-20;
  border-radius: 0 0 4px 4px;
  padding: 24px;
  box-sizing: border-box;
  background-color: $white;
  position: absolute;
  width: 100%;
  bottom: 12px;

  .add-vacancy {
    width: 100%;
    position: relative;

    .el-button {
      width: 100%;
    }
  }
}

.text-about {
  font-weight: normal;
  font-size: 14px;
  margin: 0;
  line-height: 20px;
}

.top-step {
  margin: 13px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-bottom: 1px solid $black-20;
  overflow: hidden;

  .top-step-flex {
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    vertical-align: center;
    margin-bottom: 4px;
  }
}

.step-progress-bar {
  margin: 12px 0 0 0;
}

.top-step-flex .flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;

  a {
    margin-right: 4px;
  }

  svg {
    margin-right: 4px;
  }
}

.vacancy-steps {
  max-width: 385px;

  &__footer {
    padding: 24px;
    border-top: 1px solid $black-20;
    height: 88px;

    & > .buttons-panel {
      width: 100%;
    }

    & ::v-deep .el-button {
      width: 100%;
      height: 40px;
    }
  }
}

.steps {
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
  overflow-y: auto;
}

.vacancy-name {
  font-size: 16px;
  line-height: 24px;
  align-items: bottom;
  padding: 0;
  color: $black-190;

  a {
    color: $black-190;
    text-decoration: none;
    line-height: 24px;
  }
}

.vacancy-label {
  padding: 2px 4px;
  background-color: $yellow-10;
  color: $yellow-160;
  white-space: nowrap;
  margin-right: auto;
}

.button-info {
  position: static;
  padding: 0;
  border: none;
  background: none;
  align-items: right;
  height: 24px;
}

.stage-box {
  overflow-y: auto;
  height: 100%;
  -ms-overflow-style: none;
  background-color: $background-light;
}

.empty-stages {
  height: calc(100% - 89px);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  color: $black-80;
}
</style>
